export const INITIAL_LAT = 37.09024;
export const INITIAL_LNG = -95.712891;
export const INITIAL_ZOOM = 5;
